var map = {
	"./promo-undesirable-no-1_00.jpg": 72,
	"./promo-undesirable-no-1_01.jpg": 5101,
	"./promo-undesirable-no-1_02.jpg": 71,
	"./promo-undesirable-no-1_03.jpg": 5102,
	"./promo-undesirable-no-1_04.jpg": 5103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5100;